import { UpgradeTree } from '@push.io/shared';

export const UPGRADE_HOTKEYS: Record<string, UpgradeTree> = {
  '1': UpgradeTree.Push,
  '2': UpgradeTree.Weight,
  '3': UpgradeTree.Speed,
  '4': UpgradeTree.Control,
};

export function getUpgradeHotkey(key: string, repeated: boolean): UpgradeTree | null {
  if (repeated) return null;
  return UPGRADE_HOTKEYS[key] ?? null;
}
